import React from "react";
import Interview from "../components/Interview";
import hipladeTemplate from "../../common/template";

function InterviewDetail() {
  return <Interview />;
}

// `frame`: a Entrevista é bancada de trabalho, não documento — ocupa a
// viewport, a conversa e o painel de Lacunas rolam por dentro, e o rodapé de
// marca não entra. Ver `common/template/index.tsx`.
export default hipladeTemplate(InterviewDetail, { frame: true });
